import React from 'react';
import Offer from '../components/Offer';

function Offers() {
  return (
    <>
      <div className="min-h-screen">
        <Offer />
      </div>
    </>
  );
}

export default Offers;
